import React from 'react';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { ServicesTypes } from '../../../../../types/ServicesTypes.types';

const typesList: ServicesTypes[] = [
  { id: 1, title: 'MonthlyService' },
  { id: 2, title: 'SingleService' },
  { id: 3, title: 'YearlyService' },
];

interface Props {
  value: string | undefined;
  onValueChange: (value: string) => void;
}

function TypeEditor({ value, onValueChange }: Props): JSX.Element {
  return (
    <FormControl fullWidth error>
      <Select
        input={<Input />}
        value={value || ''}
        onChange={(event) => onValueChange(event.target.value as string)}
        style={{ width: '100%' }}
        error={!value}
      >
        {typesList.map((typeItem) => (
          <MenuItem key={typeItem.id} value={typeItem.title}>
            {typeItem.title}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{value ? '' : 'Incorrect entry'}</FormHelperText>
    </FormControl>
  );
}

export default TypeEditor;
